export default "__VITE_ASSET__BF2kTQ0N__"